import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type ShareIconProps = Partial<SVGIconProps>;

const ShareIcon: FC<ShareIconProps> = (props) => (
  <SVGIcon viewBox="0 0 25 24" {...props}>
    <path
      d="M9.5 8.25H8C7.40326 8.25 6.83097 8.48705 6.40901 8.90901C5.98705 9.33097 5.75 9.90326 5.75 10.5V19.5C5.75 20.0967 5.98705 20.669 6.40901 21.091C6.83097 21.5129 7.40326 21.75 8 21.75H17C17.5967 21.75 18.169 21.5129 18.591 21.091C19.0129 20.669 19.25 20.0967 19.25 19.5V10.5C19.25 9.90326 19.0129 9.33097 18.591 8.90901C18.169 8.48705 17.5967 8.25 17 8.25H15.5M15.5 5.25L12.5 2.25M12.5 2.25L9.5 5.25M12.5 2.25V15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </SVGIcon>
);

export default ShareIcon;
